export default function SummoningCircle() {
    return (
        <ul>
            <li>Each candle requires <strong>16% (average) sanity</strong>, so lighting all five candles require a total of <strong>80% sanity</strong>.</li>
            <li>If you don't have enough sanity, the candle will be blown out immediately.</li>
            <li>If you don't have enough sanity for the <strong>last candle</strong>, then the ghost will immediately spawn on top of you and hunt.</li>
            <li>If the summoning circle is activated while the ghost is already hunting, the ghost teleports immediately to the summoning circle and hunt from there.</li>
        </ul>
    );
}